//import Profile from "components/Profile";
//import DefaultDashboard from "layout/DefaultDashboard";
import DeviceDetails from "pages/Devices/DeviceDetails";
import Devices from "pages/Devices/Devices";
import Notifications from "pages/Notifications/Notifications";
// import Home from "pages/Home/Home";
import Profile from "pages/Profile/Profile";
import React from "react";

// const Dashboard = React.lazy(() => import("layout/DefaultDashboard"));
// const Profile = React.lazy(() => import("pages/Profile/Profile"));
// const Home = React.lazy(() => import("pages/Home/Home"));

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", element: <Devices /> },
  { path: "profile", element: <Profile /> },
  { path: "notifications", element: <Notifications /> },
  { path: "devices", element: <Devices /> },
  { path: "devices/:id", element: <DeviceDetails /> },
];

export default routes;
